"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEditorTheme = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const mui_rte_1 = __importDefault(require("mui-rte"));
const clsx_1 = __importDefault(require("clsx"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const styles_1 = require("@material-ui/core/styles");
exports.defaultEditorTheme = (0, styles_1.createMuiTheme)();
Object.assign(exports.defaultEditorTheme, {
    overrides: {
        MUIRichTextEditor: {
            root: {
                height: '100%',
            },
            container: {
                display: 'flex',
                flexDirection: 'column-reverse',
                height: '100%',
            },
            editor: {
                overflowY: 'auto',
                height: '100%',
                '& ul': {
                    marginLeft: 5,
                },
                '& ol': {
                    marginLeft: 24,
                },
            },
        },
    },
});
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    editorContainer: {
        verticalAlign: 'top',
        flex: 1,
        position: 'relative',
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.05)',
    },
}));
const RichTextViewer = (props) => {
    const { value, overlay, ...otherProps } = props;
    const classes = useStyles();
    // Ensure value is always a JSON string for MUIRichTextEditor
    const getDisplayValue = () => {
        if (!value)
            return '';
        if (typeof value === 'string')
            return value;
        // If it's an object, stringify it
        return JSON.stringify(value);
    };
    return (react_1.default.createElement(Box_1.default, { ...otherProps, className: (0, clsx_1.default)(classes.editorContainer, overlay && classes.overlay) },
        react_1.default.createElement(styles_1.MuiThemeProvider, { theme: exports.defaultEditorTheme },
            react_1.default.createElement(mui_rte_1.default, { classes: { container: 'm-0' }, defaultValue: getDisplayValue(), controls: [], readOnly: true }))));
};
RichTextViewer.propTypes = {
    value: prop_types_1.default.string.isRequired,
    overlay: prop_types_1.default.bool,
};
exports.default = RichTextViewer;
